import { DispatchPermissions } from './dispatch.permissions';
import { DispatchRoles } from './dispatch.roles';

export const dispatchMappings = {
  [DispatchPermissions.PREVIEW_DISPATCH]: [DispatchRoles.PREVIEWER],
  [DispatchPermissions.GET_EVENTS]: [DispatchRoles.VIEWER],
  [DispatchPermissions.GET_LOCATION]: [DispatchRoles.VIEWER],
};
